import { render, staticRenderFns } from "./ProductAdd.vue?vue&type=template&id=1baad74f&scoped=true&lang=pug&"
import script from "./ProductAdd.vue?vue&type=script&lang=js&"
export * from "./ProductAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baad74f",
  null
  
)

export default component.exports